(function () {
  'use strict';

  const U = (window.Universe = window.Universe || {});
  const { ModalProduct, ProductForm } = U;

  if (!ModalProduct) {
    console.error('ReelModal requires ModalProduct (universe-modal-product.js) to load first.');
    return;
  }

  /**
   * ReelModal
   *
   * The UGC-carousel variant of ModalProduct. It opens from a product slide's
   * expand button and shows a vertical (TikTok/reel style) video alongside the
   * product panel:
   *   - Desktop: the video column + the full product blocks (`__content`).
   *   - Mobile:  the video + a compact complementary product card, in place of
   *              the full blocks (toggled purely by CSS).
   *
   * The video and the mobile card live in the persistent shell (via `extraSlots`)
   * rather than inside `__content`, so they survive the content rebuild that
   * happens on every variant change. All fetch / variant-refetch / a11y / focus
   * -trap / teardown logic is inherited unchanged from ModalProduct.
   *
   * Instantiated as: new ReelModal(slide, host, { view: 'reel', media, card }).
   */
  class ReelModal extends ModalProduct {
    /** Tag the shell so the reel-specific CSS (side-by-side layout) applies. */
    shellModifier() {
      return ' modal-product--reel';
    }

    /** Persistent markup injected before `__content`: the video, then the card. */
    extraSlots() {
      const media = this.options.media
        ? '<div class="modal-product__reel-media js-modal-product-reel-media">' + this.options.media + '</div>'
        : '';
      const card = this.options.card
        ? '<div class="modal-product__reel-card js-modal-product-reel-card">' + this.options.card + '</div>'
        : '';
      return media + card;
    }

    onOpened() {
      this.pauseOpenerMedia();
      this.DOM.modal.querySelectorAll('.modal-product__reel-media video').forEach((v) => v.play().catch(() => {}));
      this.wireReelCard();
    }

    beforeClose() {
      this.resumeOpenerMedia();
      this.reelCardForm?.destroy();
      this.reelCardForm = undefined;
    }

    onDestroy() {
      this.reelCardForm?.destroy();
      this.reelCardForm = undefined;
    }

    /** Pause the carousel card's own video(s) while the reel modal is open. */
    pauseOpenerMedia() {
      const card = this.openerCard || this.DOM.card;
      if (!card) return;
      this.pausedMedia = Array.from(card.querySelectorAll('video')).filter((v) => !v.paused);
      this.pausedMedia.forEach((v) => v.pause());
    }

    resumeOpenerMedia() {
      (this.pausedMedia || []).forEach((v) => v.play().catch(() => {}));
      this.pausedMedia = undefined;
    }

    /**
     * Wire the mobile-only complementary card's add-to-cart form. It lives in the
     * persistent shell (not in `__content`), so it's wired once on open and is NOT
     * rebuilt on variant change. Submitting adds the first/available variant and
     * the inherited cartUpdate handler closes the modal.
     */
    wireReelCard() {
      if (!ProductForm) return;
      const form = this.DOM.modal.querySelector('.modal-product__reel-card .js-product-form');
      if (form) this.reelCardForm = new ProductForm(form);
    }
  }

  U.ReelModal = ReelModal;
})();
